import { rand } from "./color";

const EARLY = ["#c4b5fd", "#a78bfa", "#e9d5ff", "#f9a8d4"];
const LATE = ["#f472b6", "#f9a8d4", "#fff1f7", "#fbcfe8", "#e9d5ff"];

function heartSprite(color) {
  const S = 64;
  const c = document.createElement("canvas");
  c.width = c.height = S * 2;
  const g = c.getContext("2d");
  g.translate(S, S - S * 0.5);
  g.shadowColor = color;
  g.shadowBlur = S * 0.35;
  g.fillStyle = color;
  g.beginPath();
  g.moveTo(0, S * 0.3);
  g.bezierCurveTo(0, 0, -S / 2, 0, -S / 2, S * 0.3);
  g.bezierCurveTo(-S / 2, S * 0.6, 0, S * 0.75, 0, S);
  g.bezierCurveTo(0, S * 0.75, S / 2, S * 0.6, S / 2, S * 0.3);
  g.bezierCurveTo(S / 2, 0, 0, 0, 0, S * 0.3);
  g.fill();
  g.shadowBlur = 0;
  g.fillStyle = "rgba(255,255,255,0.35)";
  g.beginPath();
  g.ellipse(-S * 0.24, S * 0.28, S * 0.09, S * 0.06, -0.6, 0, Math.PI * 2);
  g.fill();
  return c;
}

export function createLoveScene(canvas, { getOrigin, onWarmth, onComplete }) {
  const ctx = canvas.getContext("2d");
  const early = EARLY.map(heartSprite);
  const late = LATE.map(heartSprite);
  let W = 0, H = 0, dpr = 1, raf = 0, last = performance.now(), t = 0;
  let warmth = 0, reported = 0, done = false, acc = 0;
  const hearts = [];

  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = Math.floor(W * dpr);
    canvas.height = Math.floor(H * dpr);
  }

  function spawn(x, y, spread = 30) {
    const pool = Math.random() < warmth ? late : early;
    const k = Math.min(W, H) / 800 + 0.4;
    hearts.push({
      x: x + rand(-spread, spread), y: y + rand(-10, 10), vx: rand(-14, 14), vy: -rand(35, 85),
      size: rand(12, 30) * k, life: 0, dur: rand(4.5, 7.5), ph: rand(0, 6.28), sp: pool[Math.floor(Math.random() * pool.length)],
    });
  }

  function frame(now) {
    const dt = Math.min(0.05, (now - last) / 1000);
    last = now;
    t += dt;
    if (!done) warmth = Math.min(1, warmth + dt / 34);
    if (Math.abs(warmth - reported) >= 0.02 || (warmth >= 1 && !done)) {
      reported = warmth;
      onWarmth(warmth);
    }
    if (warmth >= 1 && !done) {
      done = true;
      onComplete();
    }
    acc += dt * (1.1 + warmth * 4);
    const o = getOrigin();
    while (acc > 1) {
      acc -= 1;
      spawn(o.x, o.y);
    }
    const beat = Math.exp(-((t % (1.05 - warmth * 0.3)) / 0.14));
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);
    for (let i = hearts.length - 1; i >= 0; i--) {
      const h = hearts[i];
      h.life += dt / h.dur;
      if (h.life >= 1) {
        hearts.splice(i, 1);
        continue;
      }
      h.x += (h.vx + Math.sin(t * 1.4 + h.ph) * 26) * dt;
      h.y += h.vy * dt;
      const s = h.size * (1 + 0.1 * beat) * (0.7 + h.life * 0.6);
      ctx.globalAlpha = Math.pow(Math.sin(Math.PI * h.life), 0.8) * 0.9;
      ctx.drawImage(h.sp, h.x - s, h.y - s, s * 2, s * 2);
    }
    ctx.globalAlpha = 1;
    raf = requestAnimationFrame(frame);
  }

  resize();
  window.addEventListener("resize", resize);
  raf = requestAnimationFrame(frame);

  return {
    burst(x, y) {
      if (done) return;
      warmth = Math.min(1, warmth + 0.04);
      const o = getOrigin();
      for (let i = 0; i < 7; i++) spawn(o.x, o.y, 50);
      for (let i = 0; i < 4; i++) spawn(x, y, 24);
    },
    destroy() {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    },
  };
}
